module.exports = __webpack_public_path__ + "assets/img/offierating.4125aa87.png";